import moment from "moment";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Constants } from "../libs/Constants";
import { getDefaultPeriodSelection } from "../libs/periodLib";
import { convertUTCDateInTimeZone } from "../libs/utils";

const periodDropdown = {
  fieldName: "periodSelected",
  type: "dropdown",
  options: [
    {
      key: Constants.PERIOD_TYPES.CURRENT_PERIOD,
      value: "Current Period",
    },
    {
      key: Constants.PERIOD_TYPES.LAST_PERIOD,
      value: "Last Period",
    },
    {
      key: Constants.PERIOD_TYPES.CURRENT_MONTH,
      value: "Current Month",
    },
    {
      key: Constants.PERIOD_TYPES.LAST_MONTH,
      value: "Last Month",
    },
    {
      key: Constants.PERIOD_TYPES.CURRENT_QUARTER,
      value: "Current Quarter",
    },
    {
      key: Constants.PERIOD_TYPES.LAST_QUARTER,
      value: "Last Quarter",
    },
    {
      key: Constants.PERIOD_TYPES.CURRENT_ANNUAL,
      value: "Current Annual",
    },
    {
      key: Constants.PERIOD_TYPES.LAST_ANNUAL,
      value: "Last Annual",
    },
  ],
};

const PeriodFilter = (props) => {
  const [periodSelected, setPeriodSelected] = useState(
    periodDropdown.options[0].value
  );

  useEffect(() => {
    function handle() {
      if (props.periods && props.periods.length > 0) {
        handlePeriodSelect(periodDropdown.options[0].key);
      }
    }
    handle();
  }, [props.periods]);
  function handlePeriodSelect(key) {
    let selectedPeriod = periodDropdown.options.find(
      (option) => option.key === key
    );

    setPeriodSelected(selectedPeriod.value);
    let showPeriod = null;
    let periodResponse = getDefaultPeriodSelection(props.periods);

    switch (key) {
      case Constants.PERIOD_TYPES.CURRENT_PERIOD:
        if (periodResponse) {
          showPeriod = periodResponse.currentPeriod;
        }
        break;
      case Constants.PERIOD_TYPES.LAST_PERIOD:
        if (periodResponse) {
          showPeriod =
            props.periods[
              props.periods.indexOf(periodResponse.currentPeriod) - 1
            ];
        }
        break;
      case Constants.PERIOD_TYPES.CURRENT_MONTH:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .startOf("month")
            .startOf("day")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .endOf("month")
            .endOf("day")
            .valueOf(),
        };
        break;
      case Constants.PERIOD_TYPES.LAST_MONTH:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .subtract(1, "months")
            .startOf("month")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .subtract(1, "months")
            .endOf("month")
            .valueOf(),
        };
        break;
      case Constants.PERIOD_TYPES.CURRENT_QUARTER:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .startOf("quarter")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .endOf("quarter")
            .valueOf(),
        };
        break;
      case Constants.PERIOD_TYPES.LAST_QUARTER:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .subtract(1, "Q")
            .startOf("quarter")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .subtract(1, "Q")
            .endOf("quarter")
            .valueOf(),
        };
        break;
      case Constants.PERIOD_TYPES.CURRENT_ANNUAL:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .startOf("year")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .endOf("year")
            .valueOf(),
        };
        break;
      case Constants.PERIOD_TYPES.LAST_ANNUAL:
        showPeriod = {
          periodStartdate: convertUTCDateInTimeZone(
            moment.utc(),
            props.timezone
          )
            .subtract(1, "Y")
            .startOf("year")
            .valueOf(),
          periodEnddate: convertUTCDateInTimeZone(moment.utc(), props.timezone)
            .subtract(1, "Y")
            .endOf("year")
            .valueOf(),
        };
        break;
    }
    if (!showPeriod) {
      showPeriod = {};
    }
    showPeriod.key = key;
    if (props.handlePeriodSelect) {
      props.handlePeriodSelect(showPeriod);
    }
  }
  return (
    <Dropdown>
      <Dropdown.Toggle variant="taabl" id="dropdown-basic">
        {periodSelected}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {periodDropdown.options.map((f) => {
          return (
            <Dropdown.Item
              value={f.value}
              key={f.key}
              eventKey={f.key}
              eventvalue={f.value}
              onSelect={(eventKey) => handlePeriodSelect(eventKey)}
            >
              {f.value}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default PeriodFilter;
